import React, { memo, useCallback } from 'react'
import { FormGroup, Switch, FormControlLabel } from '@mui/material'
import { SimpleSwitchProps } from './SimpleSwitch.types'

function SimpleSwitch({
    value,
    label,
    checked,
    disabled,
    placement = 'start',
    color = 'primary',
    onChanged,
}: SimpleSwitchProps) {
    const handleChange = useCallback(
        (name: string) => (event: React.ChangeEvent<{}>, checked: boolean) => {
            onChanged(name, checked)
        },
        [onChanged]
    )

    return (
        <FormGroup row>
            <FormControlLabel
                label={<small>{label}</small>}
                labelPlacement={placement}
                control={
                    <Switch
                        checked={checked}
                        onChange={handleChange(value)}
                        value={value}
                        color={color}
                        disabled={disabled}
                    />
                }
            />
        </FormGroup>
    )
}

export default memo(SimpleSwitch)
